import {
  getProductWithCategory,
  getProductWithTag,
  getUniqueCategories,
  getUniqueTags,
} from "../../helpers/product";
import React from "react";
import { setActiveSort } from "../../helpers/product";

const ShopProductTag = ({
  products,
  getSortParams,
  sideSpaceClass,
  value,
  setSortValues,
}) => {
  const uniqueTags = getUniqueTags(products)?.sort();

  return (
    <div className="row g-4">
      {uniqueTags?.map((tag) => {
        if (tag === "") return null;
        const numArt = getProductWithTag(products, tag);
        return (
          <div
            className="col-12 col-md-2"
            key={tag}
            onClick={(e) => {
              //document.querySelector("#allTags").classList.remove("active");
              if (e.currentTarget.classList.contains("active"))
                getSortParams("tag", tag, "-");
              else getSortParams("tag", tag, "+");
              setActiveSort(e);
            }}
          >
            <div className="card text-center shadow-sm border-0">
              <div className="card-body">
                <div className="p-3 bg-white text-white rounded-circle d-inline-block mb-3 border border-primary border-5">
                  <img
                    src={global.baseUrlImage + "tag/" + tag + ".png"}
                    width="32"
                    height="32"
                  />
                </div>
                <h5 className="card-title">{tag}</h5>
                <p className="card-text text-muted">{numArt} prodotti</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ShopProductTag;
